const $tabs = document.querySelector('.tabs')
const $tabsContent = document.querySelectorAll('.tabs-content');
const $tabsBtns = document.querySelectorAll('.tab');
try{

    function tabInit(tabs, tabContent, tabsBtns, tabClass, tabClassActive, tabContentActive){
        tabs.addEventListener('click', e => {
            if(e.target.classList.contains(tabClass)){
                let tabPath = e.target.dataset.tabPath;
                tabsBtns.forEach(el => el.classList.remove(tabClassActive));
                document.querySelector(`[data-tab-path='${tabPath}']`).classList.add(tabClassActive);
    
                toggleHandler(tabPath);
            }
        })
    
        function toggleHandler (path) {
            tabContent.forEach(el => {
                el.classList.remove(tabContentActive);
                el.classList.remove('tabs-content--fadeIn');
                el.classList.add('tabs-content--fadeOut')
            });
            document.querySelector(`[data-target-path='${path}']`).classList.add(tabContentActive);
            setTimeout(() => {
                document.querySelector(`[data-target-path='${path}']`).classList.remove('tabs-content--fadeOut');
                document.querySelector(`[data-target-path='${path}']`).classList.add('tabs-content--fadeIn');
            }, 100)
        }
    }
    tabInit($tabs, $tabsContent, $tabsBtns, 'tab', 'tab--active', 'tabs-content--active');


} catch(e){

}
